import { convertDateToCustomFormat } from "./utils";

export function formatRecordDetails(record) {
  if (!record?.y_datetime || !record?.y_staff || !record?.y_services?.[0])
    return null;

  return `${convertDateToCustomFormat(record.y_datetime)}, ${
    record.y_staff.y_name
  } - ${record.y_services[0].y_title}`;
}
